module.exports = __webpack_public_path__ + "img/template.1e2d1e46.svg";